module.exports = __webpack_public_path__ + "img/news2.8ede11c1.png";